import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUTopics( is_top ) {

   const edition_id = useAZZKULatestEditionID();

   return useFetchData({
      APIMethod: API.getAZZKUTopics,
      condition: !!edition_id,
      params: [ edition_id ],
      cache_name: "azzku_topics",
      resultDataHandler: data => data.map( item => ({
         value: item.id,
         label: item.name,
         variables: item.variables
            ?.filter( v => is_top ? v.is_available_in_top : true )
            ?.map( v => ({
               value: v.id,
               label: v.name
            }))
      }))
   })
}